var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgYoutubeinline = function SvgYoutubeinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon / Socials"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.203 3.337a84.03 84.03 0 0 1 2.742.061l.42.018c1.19.057 2.38.153 2.971.318a2.342 2.342 0 0 1 1.616 1.684c.333 1.3.374 3.836.38 4.45v.271c-.006.614-.047 3.15-.38 4.45-.212.82-.831 1.466-1.616 1.684-.59.165-1.78.261-2.972.317l-.42.019a84.14 84.14 0 0 1-2.74.06l-.196.001h-.213c-.942-.006-4.88-.048-6.133-.397a2.343 2.343 0 0 1-1.616-1.685c-.333-1.299-.374-3.835-.38-4.448v-.273c.006-.613.047-3.15.38-4.449.213-.82.831-1.466 1.616-1.684 1.253-.349 5.191-.391 6.133-.397h.408Zm-1.87 3.75v5.833l5-2.917-5-2.916Z",
    fill: "#fff"
  }))));
};
export default SvgYoutubeinline;